/**
 * Created by JasonChou on 17/6/14.
 */
import React, {PureComponent} from 'react'
import {merge} from '../../utils/uiUtils'

export default class Horizontal extends PureComponent {
    getElm() {
        return this.refs.raw
    }

    render() {
        const {style, vc, hc, ...other} = this.props;

        const newStyle = {};

        if (vc) {
            newStyle.alignItems = 'center'
        }

        if (hc) {
            newStyle.justifyContent = 'center'
        }

        return <div ref={'raw'} style={merge(newStyle, style)} className="h" {...other} />
    }
}




// WEBPACK FOOTER //
// ./src/components/layouts/Horizontal.js